module.exports = __webpack_public_path__ + "static/media/Slice28@2x.6005602e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/Slice28@2x.png
// module id = 1457
// module chunks = 0